import { render, staticRenderFns } from "./tabArrivalInformation.vue?vue&type=template&id=034ff2d9&scoped=true&"
import script from "./tabArrivalInformation.vue?vue&type=script&lang=js&"
export * from "./tabArrivalInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034ff2d9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('034ff2d9')) {
      api.createRecord('034ff2d9', component.options)
    } else {
      api.reload('034ff2d9', component.options)
    }
    module.hot.accept("./tabArrivalInformation.vue?vue&type=template&id=034ff2d9&scoped=true&", function () {
      api.rerender('034ff2d9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaImport/components/SiBooking/tabs/tabArrivalInformation.vue"
export default component.exports